import { createAction } from '@ngrx/store';

export const setLoader = createAction('[Loader Component] Set Loader');
export const showLoader = createAction('[Loader Component] Show Loader');
export const closeLoader = createAction('[Loader Component] Close Loader');
